module.exports = __webpack_public_path__ + "img/TopPro.b11a17de.svg";